const _excluded = ["dashboardData", "labels"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PieChart from '@rd-web-markets/shared/dist/dashboards/components/PieChart';
import DashCard from '@rd-web-markets/shared/dist/dashboards/components/DashCard';
const ClaimGroupProjectStatePieChart = _ref => {
  var _dashboardData$projec;
  let {
      dashboardData,
      labels = ['Completed', 'To Be Assessed', 'In Progress']
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  // we show dummy data in some dashboards
  const series = dashboardData !== null && dashboardData !== void 0 && (_dashboardData$projec = dashboardData.projectStatuses) !== null && _dashboardData$projec !== void 0 && _dashboardData$projec.length ? dashboardData.projectStatuses : [3, 4, 5];
  return /*#__PURE__*/React.createElement(DashCard, _extends({}, props, {
    title: "Project Status"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      height: '25px'
    }
  }), /*#__PURE__*/React.createElement(PieChart, {
    className: "pos-rel-top-10",
    labels: labels,
    series: series,
    label: 'Total Projects'
  }));
};
export default ClaimGroupProjectStatePieChart;